/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listScenes} from '../api'

export const useMutationListScenes = createReactQueryMutationHook('listScenes', listScenes)
